import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_GradeLevelSetup } from "../shared/data.service";
import { GradeLevelUpdateRequest } from "../shared/GradeLevelUpdateRequest";

@Component({
	selector: "app-district-edit-grade-level",
	templateUrl: "./district-edit-grade-level.component.html",
	styleUrls: ["./district-edit-grade-level.component.css"],
})
export class DistrictEditGradeLevelComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private GradeLevelSetupService: DataService_GradeLevelSetup,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SelectedGradeLevel = this.dialogConfig.data.SelectedGradeLevel;

		this.GradeLevelCD = this.SelectedGradeLevel.GradeLevelCD;
		this.GradeLevelDesc = this.SelectedGradeLevel.GradeLevelDesc;
		this.MealLimit = this.SelectedGradeLevel.MealAccountCreditLimit;
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	SelectedGradeLevel: any;

	GradeLevelCD: any = "";
	GradeLevelDesc: any = "";
	MealLimit: any = "";

	errorMessage: any = "";

	///////////////////////////////////

	///////////////////////////////////
	// Buttons
	///////////////////////////////////
	onEdit() {
		if (this.GradeLevelDesc == "") {
			this.errorMessage = "Enter a grade level description";
			return;
		}

		let parms: GradeLevelUpdateRequest = {
			GradeLevelID: this.SelectedGradeLevel.GradeLevelID,
			GradeLevelDesc: this.GradeLevelDesc,
			MealAccountCreditLimit: this.MealLimit,
		};

		var result = this.GradeLevelSetupService.GradeLevelUpdateInfo(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Grade Level was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Grade Level",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////
}
